import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import { breakpoints } from 'gatsby-theme-docz/src/theme/breakpoints';
import global from 'gatsby-theme-docz/src/theme/global';
export var Content = _styled("div", {
  target: "e10j0xs0"
})("width:100%;a.link{color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.link;
}, ";&:hover{opacity:0.9;}}@media screen and (max-width:", breakpoints.mobile, "px){table{display:block;overflow:auto;min-width:520px;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy90dXNoYXJmNS9kZXYvZ2l0aHViL25hdHNjYWxlL3JlYWN0LWNhbGVuZGFyL2RvY3Mvbm9kZV9tb2R1bGVzL0BuZWpjbS9kb2N6LXRoZW1lLWV4dGVuZGVkL3NyYy9nYXRzYnktdGhlbWUtZG9jei9jb21wb25lbnRzL0xheW91dC9jdXN0b20tc3R5bGVzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlpQyIsImZpbGUiOiIvVXNlcnMvdHVzaGFyZjUvZGV2L2dpdGh1Yi9uYXRzY2FsZS9yZWFjdC1jYWxlbmRhci9kb2NzL25vZGVfbW9kdWxlcy9AbmVqY20vZG9jei10aGVtZS1leHRlbmRlZC9zcmMvZ2F0c2J5LXRoZW1lLWRvY3ovY29tcG9uZW50cy9MYXlvdXQvY3VzdG9tLXN0eWxlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7YnJlYWtwb2ludHN9IGZyb20gJ2dhdHNieS10aGVtZS1kb2N6L3NyYy90aGVtZS9icmVha3BvaW50cyc7XG5pbXBvcnQgZ2xvYmFsIGZyb20gJ2dhdHNieS10aGVtZS1kb2N6L3NyYy90aGVtZS9nbG9iYWwnO1xuXG5leHBvcnQgY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIHdpZHRoOiAxMDAlO1xuXG4gIGEubGluayB7XG4gICAgY29sb3I6ICR7KHt0aGVtZX0pID0+IHRoZW1lLmNvbG9ycy5saW5rfTtcblxuICAgICY6aG92ZXIge1xuICAgICAgb3BhY2l0eTogMC45O1xuICAgIH1cbiAgfVxuXG4gIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6ICR7YnJlYWtwb2ludHMubW9iaWxlfXB4KSB7XG4gICAgdGFibGUge1xuICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgICBvdmVyZmxvdzogYXV0bztcbiAgICAgIG1pbi13aWR0aDogNTIwcHg7XG4gICAgfVxuICB9XG5gO1xuXG5leHBvcnQgY29uc3QgZ2xvYmFsU3R5bGVzID0ge1xuICAuLi5nbG9iYWwsXG4gICcqJzoge1xuICAgIGJveFNpemluZzogJ2JvcmRlci1ib3gnLFxuICB9LFxuICAnLmgtbzpob3Zlcic6IHtcbiAgICB0cmFuc2l0aW9uOiAnb3BhY2l0eSAuMnMgZWFzZScsXG4gICAgb3BhY2l0eTogJy44JyxcbiAgfSxcbiAgJ2J1dHRvbiwgc2VsZWN0LCBpbnB1dCwgdGV4dGFyZWEnOiB7XG4gICAgZm9udEZhbWlseTogJ2luaGVyaXQnLFxuICB9LFxuICBhOiB7XG4gICAgY29sb3I6ICh7dGhlbWV9KSA9PiB0aGVtZS5jb2xvcnMucHJpbWFyeSxcbiAgfSxcbiAgJ2E6aG92ZXInOiB7XG4gICAgdGV4dERlY29yYXRpb246ICd1bmRlcmxpbmUnLFxuICB9LFxufTtcbiJdfQ== */"));

if (typeof Content !== 'undefined' && Content && Content === Object(Content) && Object.isExtensible(Content) && !Object.prototype.hasOwnProperty.call(Content, '__filemeta')) {
  Object.defineProperty(Content, '__filemeta', {
    configurable: true,
    value: {
      name: "Content",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Layout/custom-styles.js"
    }
  });
}

export var globalStyles = _objectSpread(_objectSpread({}, global), {}, {
  '*': {
    boxSizing: 'border-box'
  },
  '.h-o:hover': {
    transition: 'opacity .2s ease',
    opacity: '.8'
  },
  'button, select, input, textarea': {
    fontFamily: 'inherit'
  },
  a: {
    color: function color(_ref2) {
      var theme = _ref2.theme;
      return theme.colors.primary;
    }
  },
  'a:hover': {
    textDecoration: 'underline'
  }
});

if (typeof globalStyles !== 'undefined' && globalStyles && globalStyles === Object(globalStyles) && Object.isExtensible(globalStyles) && !Object.prototype.hasOwnProperty.call(globalStyles, '__filemeta')) {
  Object.defineProperty(globalStyles, '__filemeta', {
    configurable: true,
    value: {
      name: "globalStyles",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Layout/custom-styles.js"
    }
  });
}